import { FieldConfig, FieldType } from '../DynamicForm/types'

/**
 * Normalizes a single bulk-edit form value to the shape the backend expects for
 * its field type. Empty/cleared values (`''`/`null`/`undefined`) are left
 * untouched so the mutation layer can map them to a property clear.
 */
export function normalizeBulkEditValue(
  field: FieldConfig,
  value: unknown,
): unknown {
  switch (field.type) {
    case FieldType.NUMBER: {
      if (value === null || value === undefined || value === '') {
        return value
      }
      const numericValue = Number(value)
      return Number.isFinite(numericValue) ? numericValue : value
    }
    case FieldType.DATETIME:
      return value === '' || value === 0 || value === '0' ? null : value
    case FieldType.CHECKBOX:
      return value === true || value === 'true'
    default:
      return value
  }
}

/**
 * Builds the bulk-edit `changes` payload from the currently-added fields.
 * Iterates the added-field set (not the raw form data) so values left behind by
 * a removed field never leak into the payload.
 */
export function buildBulkEditChanges(
  selectedFields: FieldConfig[],
  formData: Record<string, unknown>,
): Record<string, unknown> {
  return selectedFields.reduce(
    (changes, field) => {
      changes[field.name] = normalizeBulkEditValue(field, formData[field.name])
      return changes
    },
    {} as Record<string, unknown>,
  )
}
